import { IColorbar } from '../models/interfaces/IColorbar';

export class Colorbar {
    public static BINARY : IColorbar = {
        Token: '36403263-67cb-4811-851b-bdda032cafa2',
        Label: 'Grayscale',
        Name: 'binary',
        Picture: 'https://filemanager.geopostenergy.com/white_black_200_colorbar.jpg',
        Background: '#7F7F7F'
    };

    public static RWB : IColorbar = {
        Token: '3bc1ddc4-bcfe-4d1a-86ca-91708ca6cd53',
        Label: 'RWB',
        Name: 'seismic',
        Picture: 'https://filemanager.geopostenergy.com/12f0403b465902ac298631ef1bb968041703116963424.png',
        Background: '#FFFFFF'
    };

    public static RWG : IColorbar = {
        Token: '2a68b614-7cc9-4a8b-bf6e-afdce399005f',
        Label: 'RWG',
        Name: 'RdGy',
        Picture: 'https://filemanager.geopostenergy.com/9c031a8d7de010afdf4d72f9fd806af91708520684130.jpg',
        Background: '#FBFBFB'
    };

    public static REDS : IColorbar = {
        Token:'reds',
        Name:'Reds',
        Label: 'Reds',
        Picture: 'https://filemanager.geopostenergy.com/6f8cb095cf25ba89a5a817da88c5465b1729018864181.jpeg',
        Background: '#FFFFFF'
    };

    public static JET : IColorbar = {
        Token: 'jet',
        Name: 'jet',
        Label: 'Jet',
        Picture: 'https://filemanager.geopostenergy.com/30164128316b2fabc5ca647ad48388be1729019016024.jpeg',
        Background: '#FFFFFF'
    };

    public static defaultColorbarList = [
        Colorbar.BINARY,
        Colorbar.RWB,
        Colorbar.RWG
    ];
};